import { defineComponent, ref } from "@vue/composition-api";
import PageHeader from "@Shared/components/general/page-header.vue";
import MortgageCalculatorsTabs from "./mortgage-calculators-tabs.vue";
export default defineComponent({
  name: "MortgageCalculatorsContainer",
  components: {
    MortgageCalculatorsTabs,
    PageHeader
  },
  setup() {
    const loading = ref(true);
    const runningReport = ref({
      loading: false,
      loadingSucceeded: true,
      disabled: false
    });
    return {
      loading,
      runningReport
    };
  }
});